import * as React from 'react';
import ReactDOM from 'react-dom';
import FoxGame from './feat/game/FoxGame';

const app = document.getElementById('react-app');
ReactDOM.render(<FoxGame />, app);
